import React from 'react';

export type SideNavModalOpenOptions = {
	title?: React.ReactNode;
	searchPlaceholder?: string;
	navAriaLabel?: string;
	/** Id of the side nav item to select when the modal opens (e.g. 'connected-apps') */
	defaultSelectedId?: string;
	/** When true, Connected apps content scrolls to the "available to connect" section after open */
	scrollToAvailableApps?: boolean;
	/** Identifies what surface opened the modal (e.g. 'chat', 'search-qf-connect-apps-pill') for analytics attribution */
	surface?: string;
};

export type SideNavModalContextValue = {
	open: (options: SideNavModalOpenOptions) => void;
	close: () => void;
	isOpen: boolean;
	disabled: boolean;
};

export const SideNavModalContext: React.Context<SideNavModalContextValue | null> =
	React.createContext<SideNavModalContextValue | null>(null);
